import firebase from '../../firebase';

export default async function getUser({ userId }) {
    const userResponse = await firebase.functions().httpsCallable('users-get')({ userId });
    return userResponse.data || {};
}
